export const donViTinh = {
  sections: {
    list: { title: 'Units of measure' },
    detail: { title: 'Unit of measure' },
  },
  titles: { add: 'Add unit', edit: 'Edit unit', create: 'Create unit' },
  columns: {
    code: 'Code',
    summary: 'Unit name',
    note: 'Note',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    status: 'Status',
    onOffAction: 'On/Off',
  },
  filter: {
    searchPlaceholder: 'Search by code or name...',
    textDetailTitle: 'Detail filters',
  },
  filters: {
    hintSection: 'Hint',
    hintBody: 'Catalog of units used on products.',
    statusAll: 'All',
  },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
  },
  actions: {
    pause: 'Deactivate',
    activate: 'Activate',
  },
  messages: {
    loadError: 'Could not load units.',
    deleteSuccess: 'Unit deleted.',
    noData: 'No units.',
    listSummary: '{count} item(s)',
    saveSuccess: 'Unit saved.',
    createSuccess: 'Unit created',
    statusChanged: 'Status updated.',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected unit(s)?',
    bulkDeleteSuccess: 'Deleted {count} unit(s)',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No units selected to delete',
  },
  form: {
    tenDonViTinh: 'Unit name',
    maDonViTinh: 'Code (optional)',
    ghiChu: 'Note',
  },
  validation: {
    tenRequired: 'Unit name is required.',
  },
  import: {
    description:
      'Excel file has 3 columns: Unit code (optional), Unit name (required), Note (optional). Empty code will be auto-generated. Existing codes will be updated.',
    success: 'Units imported from Excel.',
    failed: 'Unit import from Excel failed.',
    empty: 'Excel file has no valid data rows.',
  },
  placeholders: {
    formTitle: 'Unit of measure',
    formBody: '',
    tenDonViTinh: 'Enter unit name',
  },
}
